import React, { Component } from 'react';

class Portfolio extends Component {
  render() {

    if (this.props.data) {
      var psychProjects = this.props.data.psychProjects.map(function (projects) {
        const shoot = () => {
          console.log('projects:', projects);
          window.open(projects.url)
        }
        var projectImage = 'images/portfolio/' + projects.image;
        return <div key={projects.title} className="columns portfolio-item">
          <div className="item-wrap">
            <a onClick={shoot} title={projects.title}>
              <img alt={projects.title} className="portfolio-image" src={projectImage} />
              <div className="overlay">
                <div className="portfolio-item-meta">
                  <h5>{projects.title}</h5>
                </div>
              </div>
              <div className="link-icon"><i className="fa fa-link"></i></div>
            </a>
          </div>
        </div>
      })

      var webDevProjects = this.props.data.webDevProjects.map(function (projects) {
        const shoot = () => {
          console.log('projects:', projects);
          window.open(projects.url)
        }
        var projectImage = 'images/portfolio/' + projects.image;
        return <div key={projects.title} className="columns portfolio-item">
          <div className="item-wrap">
            <a onClick={shoot} title={projects.title}>
              <img alt={projects.title} className="portfolio-image" src={projectImage} />
              <div className="overlay">
                <div className="portfolio-item-meta">
                  <h5>{projects.title}</h5>
                </div>
              </div>
              <div className="link-icon"><i className="fa fa-link"></i></div>
            </a>
          </div>
        </div>
      })


      var otherProjects = this.props.data.otherProjects.map(function (projects) {
        const shoot = () => {
          console.log('projects:', projects);
          window.open(projects.url)
        }
        var projectImage = 'images/portfolio/' + projects.image;
        return <div key={projects.title} className="columns portfolio-item">
          <div className="item-wrap">
            <a onClick={shoot} title={projects.title}>
              <img alt={projects.title} className="portfolio-image" src={projectImage} />
              <div className="overlay">
                <div className="portfolio-item-meta">
                  <h5>{projects.title}</h5>
                </div>
              </div>
              <div className="link-icon"><i className="fa fa-link"></i></div>
            </a>
          </div>
        </div>
      })


    }

    return (
      <section id="portfolio">

        <div className="row">

          <div className="twelve columns collapsed">

            <h1>Check out some of my work.</h1>
            <span className="mobile_disclaimer">View them on your computer (or) use Desktop Site in your browser when they open.</span>
            <h3>Psychology Games/Experiments</h3>
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
              {psychProjects}
            </div>
            <h3>E-commerce</h3>
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
              {webDevProjects}
            </div>
            {/* <h3>3D/Gaming/XR</h3> */}
            {/* <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
              {otherProjects}
            </div> */}
            <h5>Note: These are few demos and not the exact projects I worked on. I adhere to maintain the IP of the companies/clients I worked with confidential.</h5>

          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;
